import { stripLocalePrefix } from '../i18n/localeRouting';

/** 플로팅 랜딩 헤더 + brand-story-page 레이아웃을 쓰는 경로 */
export function isLandingStylePath(pathname: string): boolean {
  const path = stripLocalePrefix(pathname);
  return (
    path === '/' ||
    path.startsWith('/brand-story') ||
    path.startsWith('/service') ||
    path.startsWith('/use-cases') ||
    path.startsWith('/blog') ||
    path.startsWith('/contact')
  );
}

export function isBrandStoryLayoutPath(pathname: string): boolean {
  const path = stripLocalePrefix(pathname);
  return (
    path.startsWith('/brand-story') ||
    path.startsWith('/service') ||
    path.startsWith('/use-cases') ||
    path.startsWith('/blog') ||
    path.startsWith('/contact')
  );
}
